// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1002": "1badcec7","1686": "1fffc51b","3993": "e9710413","4066": "b9d1fdde","7333": "baf5acdb","8404": "082e688e",}[chunkId] + ".css"
}